export const getSessionToken = async (): Promise<string | null> => {
  if (!window.Clerk?.session) return null;
  return (await window?.Clerk?.session?.getToken()) ?? null;
};
